/**
 * Automated Systems Process — five-phase engagement flow.
 * Renamed from process.js, retitled "How we ship automated systems".
 * Same 5-phase structure, reframed for the automated systems context.
 *
 * NOTE: No em dashes per voice rules.
 */

export const processHead = {
  eyebrow: 'Process',
  heading: 'How we ship automated systems.',
  description:
    'Five phases from first call to a system running in production. No twelve-week discovery marathons. No vague deliverables. Each phase ends with something you can hold: a roadmap, a quote, a working build, a trained team, a measured result.',
};

export const processSteps = [
  {
    title: 'Audit',
    body:
      'Map the work your organisation is actually performing. The repetition, the bottlenecks, the handoffs. We rank the highest-return opportunities and hand you a roadmap before anything gets built.',
    items: ['Workflow audit', 'Stack and data review', 'ROI-ranked roadmap'],
  },
  {
    title: 'Strategy',
    body:
      'Turn the roadmap into an engagement plan: the solution architecture, the build order, and the outcome each piece will be measured against. The phase closes with a fixed-scope quote.',
    items: ['Solution architecture', 'Enablement roadmap', 'Fixed-scope quote'],
  },
  {
    title: 'Build',
    body:
      'Engineer, integrate, and test inside your environment. Weekly demonstrations replace six-week silences. Stakeholders are engaged throughout.',
    items: ['Sprint delivery', 'QA and edge-case testing', 'Integration and deployment'],
  },
  {
    title: 'Enable',
    body:
      'Train the people who will operate, extend, and improve the system. Role-specific sessions, documentation, and applied practice. Delivered before cutover, not after.',
    items: ['Role-specific training', 'Operator documentation', 'Champion identification'],
  },
  {
    title: 'Scale',
    body:
      'The structured 90-day optimisation window. We watch the system run, trim the steps that waste time and money, and expand what is working, so the outcome compounds instead of decaying after handover.',
    items: ['Impact dashboard', 'Adoption review', 'Stack expansion plan'],
  },
];
